import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Form, FormGroup, Label } from "reactstrap";
import {
  createInternalDocuments,
  getAllDocumentList,
  getCustomerAddressList,
  getDeductionList,
  getDeliveryMethodList,
  getDocumentSetList,
  getListCountry,
  getListCurrency,
  getListCustomerList,
  getListMainproduct,
  getMoloniVehiclesList,
  getTaxList,
  viewInternalDocuments,
  updateInternalDocuments,
  getMaturityDatesList,
  getListSalesmenList,
} from "../../services/MoloniServices";
import Select from "react-select";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { getCommonSearchList } from "../../services/settingsServices";



const AddInternalDocuments = () => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const { t } = useTranslation();
  const [btnLoader, setBtnLoader] = useState(false);
  const initialTax = { tax_id: 0, value: 0, order: 0, cumulative: 0 };
  const initialChildProduct = {
    product_id: 0,
    name: "",
    summary: "",
    qty: 0,
    price: 0,
    discount: 0,
    deduction_id: null,
    order: 0,
    exemption_reason: "",
    warehouse_id: null,
    taxes: [initialTax],
  };

  const initialProduct = {
    product_id: 0,
    name: "",
    summary: "",
    qty: 0,
    price: 0,
    discount: 0,
    deduction_id: null,
    order: 0,
    exemption_reason: "",
    warehouse_id: null,
    taxes: [initialTax],
  };

  const [internalDocumentData, setInternalDocumentData] = useState({
    id: "",
    moloni_id: "",
    date: new Date().toISOString().split("T")[0],
    document_set_id: "",
    customer_id: "",
    alternate_address_id: "",
    your_reference: "",
    related_documents_notes: "",
    products: [initialProduct],
    exchange_currency_id: "",
    exchange_rate: "",
    delivery_method_id: "",
    delivery_datetime: "",
    delivery_departure_address: "",
    delivery_departure_city: "",
    delivery_departure_zip_code: "",
    delivery_departure_country: "",
    delivery_destination_address: "",
    delivery_destination_city: "",
    delivery_destination_zip_code: "",
    delivery_destination_country: "",
    vehicle_id: "",
    vehicle_name: "",
    vehicle_number_plate: "",
    notes: "",
    status: 0,
    financial_discount: "",
    expiration_date: new Date().toISOString().split("T")[0],
    maturity_date_id: "",
    salesman_id: "",
    salesman_commission: "",
    special_discount: "",
  });

  const [internalDocumentViewData, setInternalDocumentViewData] = useState("");
  let errorsObj = {
    date: "",
    document_set_id: "",
    customer_id: "",
    expiration_date: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [documentSetList, setDocumentSetList] = useState([]);
  const [customerList, seCustomerList] = useState([]);
  const [vehiclesList, setVehiclesList] = useState([]);
  const [exchangeCurrList, setExchangeCurrList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [deductionList, setDeductionList] = useState([]);
  const [taxDataList, setTaxDataList] = useState([]);
  const [errorsPro, setErrorsPro] = useState({});
  const [selectedProduct, setSelectedProduct] = useState("");
  const [alternateAddressList, setAlternateAddressList] = useState([]);
  const [deliveryMethodList, setDeliveryMethodList] = useState([]);
  const [maturityDataList, setMaturityDataList] = useState([]);
  const [salesMenDataList, setSalesMenDataList] = useState([]);
  const [exemptionList, setExemptionList] = useState([]);
  
  
  
    useEffect(function () {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        type: "exception_list",
      };
      getCommonSearchList(data)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].code,
              label: response.data[i].description,
            });
          }
  
          setExemptionList(list);
        })
        .catch((err) => {});
    }, []);

  const validateProduct = (product, index) => {
    let newErrors = {};

    if (!product.product_id) newErrors.product_id = "Product is required";
    if (!product.name?.trim()) newErrors.name = "Name is required";
    if (!product.qty || product.qty <= 0)
      newErrors.qty = "Quantity is required";
    if (!product.price || product.price <= 0)
      newErrors.price = "Price is required";

    setErrorsPro((prev) => ({
      ...prev,
      [index]: newErrors,
    }));

    return Object.keys(newErrors).length === 0;
  };

  const handleAddProduct = (e) => {
    e.preventDefault();

    let list = [...internalDocumentData.products];
    list.push({ ...initialProduct });

    setInternalDocumentData({
      ...internalDocumentData,
      products: list,
    });
  };

  const handleRemoveProduct = (e, index) => {
    e.preventDefault();

    let list = [...internalDocumentData.products];
    list.splice(index, 1);

    setInternalDocumentData({
      ...internalDocumentData,
      products: list,
    });
  };

  const handleAddChildProduct = (e, productIndex) => {
    e.preventDefault();
    let list = [...internalDocumentData.products];
    if (!list[productIndex].child_products) {
      list[productIndex].child_products = [];
    }
    list[productIndex].child_products.push({ ...initialChildProduct });
    setInternalDocumentData({ ...internalDocumentData, products: list });
  };

  const handleRemoveChildProduct = (e, productIndex, childIndex) => {
    e.preventDefault();
    let list = [...internalDocumentData.products];
    list[productIndex].child_products.splice(childIndex, 1);
    setInternalDocumentData({ ...internalDocumentData, products: list });
  };

  const handleAddChildProperty = (e, productIndex, childIndex) => {
    e.preventDefault();

    let list = [...internalDocumentData.products];

    if (!list[productIndex].child_products[childIndex].properties) {
      list[productIndex].child_products[childIndex].properties = [];
    }

    list[productIndex].child_products[childIndex].properties.push({
      title: "",
      value: "",
    });

    setInternalDocumentData({
      ...internalDocumentData,
      products: list,
    });
  };

  const handleAddChildTax = (e, productIndex, childIndex) => {
    e.preventDefault();

    let list = [...internalDocumentData.products];

    if (!list[productIndex].child_products[childIndex].taxes) {
      list[productIndex].child_products[childIndex].taxes = [];
    }

    list[productIndex].child_products[childIndex].taxes.push({
      tax_id: null,
      value: 0,
      order: null,
      cumulative: 0,
    });

    setInternalDocumentData({
      ...internalDocumentData,
      products: list,
    });
  };

  const handleAddTax = (e, productIndex) => {
    e.preventDefault();

    let list = [...internalDocumentData.products];
    list[productIndex].taxes.push({ ...initialTax });

    setInternalDocumentData({
      ...internalDocumentData,
      products: list,
    });
  };

  const handleRemoveTax = (e, productIndex, taxIndex) => {
    e.preventDefault();

    let list = [...internalDocumentData.products];
    list[productIndex].taxes.splice(taxIndex, 1);

    setInternalDocumentData({
      ...internalDocumentData,
      products: list,
    });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDeliveryMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDeliveryMethodList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (uuid) {
      let data = { id: uuid };
      viewInternalDocuments(data)
        .then((response) => {
          setInternalDocumentViewData(response.data.data);
        })
        .catch((err) => {
          navigate("/estimates");
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [uuid]);

  useEffect(() => {
    if (internalDocumentViewData) {
      setInternalDocumentData({
        id: internalDocumentViewData?.id,
        date: internalDocumentViewData?.date,
        document_set_id: internalDocumentViewData?.document_set_id,
        customer_id: internalDocumentViewData?.customer_id,
        alternate_address_id: internalDocumentViewData?.alternate_address_id,
        your_reference: internalDocumentViewData?.your_reference,
        related_documents_notes:
          internalDocumentViewData?.related_documents_notes,
        products: internalDocumentViewData?.products,
        exchange_currency_id: internalDocumentViewData?.exchange_currency_id,
        exchange_rate: internalDocumentViewData?.exchange_rate,
        delivery_method_id: internalDocumentViewData?.delivery_method_id,
        delivery_datetime: internalDocumentViewData?.delivery_datetime,
        delivery_departure_city:
          internalDocumentViewData?.delivery_departure_city,
        delivery_departure_zip_code:
          internalDocumentViewData?.delivery_departure_zip_code,
        delivery_departure_country:
          internalDocumentViewData?.delivery_departure_country,
        delivery_destination_address:
          internalDocumentViewData?.delivery_destination_address,
        delivery_destination_city:
          internalDocumentViewData?.delivery_destination_city,
        delivery_destination_zip_code:
          internalDocumentViewData?.delivery_destination_zip_code,
        delivery_destination_country:
          internalDocumentViewData?.delivery_destination_country,
        vehicle_id: internalDocumentViewData?.vehicle_id,
        vehicle_name: internalDocumentViewData?.vehicle_name,
        vehicle_number_plate: internalDocumentViewData?.vehicle_number_plate,
        notes: internalDocumentViewData?.notes,
        status: internalDocumentViewData?.status,
        financial_discount: internalDocumentViewData?.financial_discount,
        delivery_departure_address:
          internalDocumentViewData?.delivery_departure_address,
        expiration_date: internalDocumentViewData?.expiration_date,
        maturity_date_id: internalDocumentViewData?.maturity_date_id,
        salesman_id: internalDocumentViewData?.salesman_id,
        salesman_commission: internalDocumentViewData?.salesman_commission,
        special_discount: internalDocumentViewData?.special_discount,
      });
    }
  }, [internalDocumentViewData]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getMaturityDatesList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setMaturityDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListSalesmenList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setSalesMenDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDeductionList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDeductionList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListMainproduct(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
            price: response.data[i].price,
            stock: response.data[i].stock,
            exemption_reason: response.data[i].exemption_reason,
            taxes: response.data[i].taxes,
            properties: response.data[i].properties,
            warehouse: response.data[i].warehouse,
          });
        }

        setProductList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (selectedProduct) {
      const initialProduct = {
        product_id: selectedProduct?.value,
        name: selectedProduct.label || "",
        summary: "",
        qty: selectedProduct.stock || 0,
        price: selectedProduct.price || 0,
        discount: 0,
        deduction_id: "",
        order: 0,
        exemption_reason: "",
        warehouse_id: selectedProduct.warehouse,
        properties: selectedProduct.properties || [],
        taxes: selectedProduct.taxes || [],
      };

      setInternalDocumentData((prev) => ({
        ...prev,
        products: [initialProduct],
      }));
    }
  }, [selectedProduct]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getTaxList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setTaxDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(
    function () {
      if (internalDocumentData?.customer_id) {
        let data = {
          limit: 20,
          page: 1,
          search: "",
          customer_id: internalDocumentData?.customer_id,
        };
        getCustomerAddressList(data)
          .then((res) => {
            const response = res.data.address;

            let list = [];
            for (let i = 0; i < response.length; i++) {
              list.push({
                value: response[i].moloni_id,
                label: response[i].name,
              });
            }

            setAlternateAddressList(list);
          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
          });
      }
    },
    [internalDocumentData],
  );

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setCountryList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCurrency(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setExchangeCurrList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCustomerList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        seCustomerList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getMoloniVehiclesList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].description,
          });
        }

        setVehiclesList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    setBtnLoader(true);

    let error = false;
    let errorObj = { ...errorsObj };
    if (!internalDocumentData?.date) {
      errorObj.date = `Date is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!internalDocumentData.expiration_date) {
      errorObj.expiration_date = `Expiration Date is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (internalDocumentData?.date && internalDocumentData?.expiration_date) {
      const start = new Date(internalDocumentData.date);
      const end = new Date(internalDocumentData.expiration_date);

      if (end < start) {
        errorObj.expiration_date = "Expiration Date must be after Date.";
        error = true;
      }
    }

    if (!internalDocumentData.document_set_id) {
      errorObj.document_set_id = `Document Set is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!internalDocumentData.customer_id) {
      errorObj.customer_id = `Customer is required.`;
      error = true;
      setBtnLoader(false);
    }

    let allValid = true;
    internalDocumentData?.products.forEach((product, i) => {
      if (!validateProduct(product, i)) {
        allValid = false;
      }
    });

    if (!allValid) {
      toast.error("Product is Required");
      return;
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    let data = {
      date: internalDocumentData?.date,
      document_set_id: internalDocumentData?.document_set_id,
      customer_id: internalDocumentData?.customer_id,
      alternate_address_id: internalDocumentData?.alternate_address_id,
      your_reference: internalDocumentData?.your_reference,
      related_documents_notes: internalDocumentData?.related_documents_notes,
      products: internalDocumentData?.products,
      exchange_currency_id: internalDocumentData?.exchange_currency_id,
      exchange_rate: internalDocumentData?.exchange_rate,
      delivery_method_id: internalDocumentData?.delivery_method_id,
      delivery_datetime: internalDocumentData?.delivery_datetime,
      delivery_departure_city: internalDocumentData?.delivery_departure_city,
      delivery_departure_zip_code:
        internalDocumentData?.delivery_departure_zip_code,
      delivery_departure_country:
        internalDocumentData?.delivery_departure_country,
      delivery_destination_address:
        internalDocumentData?.delivery_destination_address,
      delivery_destination_city:
        internalDocumentData?.delivery_destination_city,
      delivery_destination_zip_code:
        internalDocumentData?.delivery_destination_zip_code,
      delivery_destination_country:
        internalDocumentData?.delivery_destination_country,
      vehicle_id: internalDocumentData?.vehicle_id,
      vehicle_name: internalDocumentData?.vehicle_name,
      vehicle_number_plate: internalDocumentData?.vehicle_number_plate,
      notes: internalDocumentData?.notes,
      status: internalDocumentData?.status,
      financial_discount: internalDocumentData?.financial_discount,
      delivery_departure_address:
        internalDocumentData?.delivery_departure_address,
      expiration_date: internalDocumentData?.expiration_date,
      maturity_date_id: internalDocumentData?.maturity_date_id,
      salesman_id: internalDocumentData?.salesman_id,
      salesman_commission: internalDocumentData?.salesman_commission,
      special_discount: internalDocumentData?.special_discount,
    };

    let updateData = {
      id: internalDocumentData?.id,
      document_id: internalDocumentViewData?.document_id,
      date: internalDocumentData?.date,
      document_set_id: internalDocumentData?.document_set_id,
      customer_id: internalDocumentData?.customer_id,
      alternate_address_id: internalDocumentData?.alternate_address_id,
      your_reference: internalDocumentData?.your_reference,
      special_discount: internalDocumentData?.special_discount,
      related_documents_notes: internalDocumentData?.related_documents_notes,
      products: internalDocumentData?.products,
      exchange_currency_id: internalDocumentData?.exchange_currency_id,
      exchange_rate: internalDocumentData?.exchange_rate,
      delivery_method_id: internalDocumentData?.delivery_method_id,
      delivery_datetime: internalDocumentData?.delivery_datetime,
      delivery_departure_city: internalDocumentData?.delivery_departure_city,
      delivery_departure_zip_code:
        internalDocumentData?.delivery_departure_zip_code,
      delivery_departure_country:
        internalDocumentData?.delivery_departure_country,
      delivery_destination_address:
        internalDocumentData?.delivery_destination_address,
      delivery_destination_city:
        internalDocumentData?.delivery_destination_city,
      delivery_destination_zip_code:
        internalDocumentData?.delivery_destination_zip_code,
      delivery_destination_country:
        internalDocumentData?.delivery_destination_country,
      vehicle_id: internalDocumentData?.vehicle_id,
      vehicle_name: internalDocumentData?.vehicle_name,
      vehicle_number_plate: internalDocumentData?.vehicle_number_plate,
      notes: internalDocumentData?.notes,
      status: internalDocumentData?.status,
      financial_discount: internalDocumentData?.financial_discount,
      delivery_departure_address:
        internalDocumentData?.delivery_departure_address,
      expiration_date: internalDocumentData?.expiration_date,
      maturity_date_id: internalDocumentData?.maturity_date_id,
      salesman_id: internalDocumentData?.salesman_id,
      salesman_commission: internalDocumentData?.salesman_commission,
    };

    if (internalDocumentViewData?.id) {
      updateInternalDocuments(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/internalDocuments");
          setInternalDocumentData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    } else {
      createInternalDocuments(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/internalDocuments");
          setInternalDocumentData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid container-custom-height-new">
            <div className="row mb-2">
              <div className="col-sm-12 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-document")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
                <h1 className="page-title ms-auto mb-2">
                  {t("internalDocuments")}
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="row justify-content-start">
              <div className="col-md-12">
                <Form method={`post`} onSubmit={handleSubmit}>
                  <div className="card card-primary">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("date")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="date"
                                  value={internalDocumentData.date}
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      date: e.target.value,
                                    });
                                  }}
                                  name="date"
                                  placeholder="Select Date"
                                />
                              </div>
                              {errors.date && (
                                <span className="input-error">
                                  {errors.date}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("expirationDate")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="date"
                                  value={internalDocumentData.expiration_date}
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      expiration_date: e.target.value,
                                    });
                                  }}
                                  name="expiration_date"
                                  placeholder="Expiration Date"
                                />
                              </div>
                              {errors.expiration_date && (
                                <span className="input-error">
                                  {errors.expiration_date}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("maturityDate")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={maturityDataList}
                                  value={maturityDataList.find(
                                    (item) =>
                                      item.value ===
                                      internalDocumentData.maturity_date_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      maturity_date_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Maturity Date"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("documentSet")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={documentSetList}
                                  value={documentSetList.find(
                                    (item) =>
                                      item.value ===
                                      internalDocumentData.document_set_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      document_set_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Document Set"}
                                />
                                {errors.document_set_id && (
                                  <span className="input-error">
                                    {errors.document_set_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("customer")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={customerList}
                                  value={customerList.find(
                                    (item) =>
                                      item.value ===
                                      internalDocumentData.customer_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      customer_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Customer"}
                                />
                                {errors.customer_id && (
                                  <span className="input-error">
                                    {errors.customer_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("alternate_address")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={alternateAddressList}
                                  value={alternateAddressList.find(
                                    (item) =>
                                      item.value ===
                                      internalDocumentData.alternate_address_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      alternate_address_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Alternate Address"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("financial_discount")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={
                                    internalDocumentData.financial_discount
                                  }
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      financial_discount: e.target.value,
                                    });
                                  }}
                                  name="financial_discount"
                                  placeholder="Financial Discount"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("your_reference")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={internalDocumentData.your_reference}
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      your_reference: e.target.value,
                                    });
                                  }}
                                  name="your_reference"
                                  placeholder="Your Reference"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("salesman")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={salesMenDataList}
                                  value={salesMenDataList.find(
                                    (item) =>
                                      item.value ===
                                      internalDocumentData.salesman_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      salesman_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Salesman"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("salesman_commission")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={
                                    internalDocumentData.salesman_commission
                                  }
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      salesman_commission: e.target.value,
                                    });
                                  }}
                                  name="salesman_commission"
                                  placeholder="Salesman Commission"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("special_discount")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={internalDocumentData.special_discount}
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      special_discount: e.target.value,
                                    });
                                  }}
                                  name="special_discount"
                                  placeholder="Special Discount"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("related_documents_notes")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    internalDocumentData.related_documents_notes
                                  }
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      related_documents_notes: e.target.value,
                                    });
                                  }}
                                  name="related_documents_notes"
                                  placeholder="Related Documents Notes"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("exchange_currency")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={exchangeCurrList}
                                  value={exchangeCurrList.find(
                                    (item) =>
                                      item.value ===
                                      internalDocumentData.exchange_currency_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      exchange_currency_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Exchange Currency"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("exchange_rate")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={internalDocumentData.exchange_rate}
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      exchange_rate: e.target.value,
                                    });
                                  }}
                                  name="exchange_rate"
                                  placeholder="Exchange Rate"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_datetime")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="date"
                                  value={internalDocumentData.delivery_datetime}
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      delivery_datetime: e.target.value,
                                    });
                                  }}
                                  name="delivery_datetime"
                                  placeholder="Select Delivery Date"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my">
                              {t("deliveryMethod")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={deliveryMethodList}
                                  value={deliveryMethodList.find(
                                    (item) =>
                                      item.value ===
                                      internalDocumentData.delivery_method_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      delivery_method_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Delivery Method"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_departure_address")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    internalDocumentData.delivery_departure_address
                                  }
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      delivery_departure_address:
                                        e.target.value,
                                    });
                                  }}
                                  name="delivery_departure_address"
                                  placeholder="Delivery Departure Address"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_destination_address")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    internalDocumentData.delivery_destination_address
                                  }
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      delivery_destination_address:
                                        e.target.value,
                                    });
                                  }}
                                  name="delivery_destination_address"
                                  placeholder="Delivery Destination Address"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_departure_city")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    internalDocumentData.delivery_departure_city
                                  }
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      delivery_departure_city: e.target.value,
                                    });
                                  }}
                                  name="delivery_departure_city"
                                  placeholder="Delivery Departure city"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_destination_city")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    internalDocumentData.delivery_destination_city
                                  }
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      delivery_destination_city: e.target.value,
                                    });
                                  }}
                                  name="delivery_destination_city"
                                  placeholder="Delivery Departure city"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_departure_zip_code")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    internalDocumentData.delivery_departure_zip_code
                                  }
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      delivery_departure_zip_code:
                                        e.target.value,
                                    });
                                  }}
                                  name="delivery_departure_zip_code"
                                  placeholder="Delivery Departure Zipcode"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_destination_zip_code")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    internalDocumentData.delivery_destination_zip_code
                                  }
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      delivery_destination_zip_code:
                                        e.target.value,
                                    });
                                  }}
                                  name="delivery_destination_zip_code"
                                  placeholder="Delivery Departure Zipcode"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_destination_country")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={countryList}
                                  value={countryList.find(
                                    (item) =>
                                      item.value ===
                                      internalDocumentData.delivery_destination_country,
                                  )}
                                  onChange={(selectedOption) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      delivery_destination_country:
                                        selectedOption
                                          ? selectedOption.value
                                          : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Country"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_departure_country")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={countryList}
                                  value={countryList.find(
                                    (item) =>
                                      item.value ===
                                      internalDocumentData.delivery_departure_country,
                                  )}
                                  onChange={(selectedOption) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      delivery_departure_country: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Country"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("vehicle")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={vehiclesList}
                                  value={vehiclesList.find(
                                    (item) =>
                                      item.value ===
                                      internalDocumentData.vehicle_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      vehicle_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Vehicle"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("vehicle_name")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={internalDocumentData.vehicle_name}
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      vehicle_name: e.target.value,
                                    });
                                  }}
                                  name="vehicle_name"
                                  placeholder="Vehicle Name"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("vehicle_number_plate")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    internalDocumentData.vehicle_number_plate
                                  }
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      vehicle_number_plate: e.target.value,
                                    });
                                  }}
                                  name="vehicle_number_plate"
                                  placeholder="Vehicle Number Plate"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("notes")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={internalDocumentData.notes}
                                  onChange={(e) => {
                                    setInternalDocumentData({
                                      ...internalDocumentData,
                                      notes: e.target.value,
                                    });
                                  }}
                                  name="notes"
                                  placeholder="Notes"
                                  rows={3}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("status")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <div className="form-check">
                                  <input
                                    className="my-checkbox-1 form-check-input"
                                    type="checkbox"
                                    checked={internalDocumentData.status === 1}
                                    onChange={(e) => {
                                      setInternalDocumentData({
                                        ...internalDocumentData,
                                        status: e.target.checked ? 1 : 0,
                                      });
                                    }}
                                  />
                                  <label className="form-check-label pl-2">
                                    {t("status")}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </FormGroup>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card card-primary">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{
                              marginTop: "15px",
                              marginBottom: "15px",
                            }}
                          >
                            {" "}
                            <h5>{t("products")}</h5>
                            <button
                              className="btn btn-primary"
                              onClick={handleAddProduct}
                              type="button"
                            >
                              + {t("add_product")}
                            </button>
                          </div>

                          {internalDocumentData?.products?.map((product, i) => (
                            <div key={i} className="card p-3 mb-3">
                              <h5>Product {i + 1}</h5>
                              <div className="row">
                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("product")}
                                    </Label>
                                    <Select
                                      className="my-select-v"
                                      options={productList}
                                      value={productList.find(
                                        (item) =>
                                          item.value ===
                                          String(
                                            internalDocumentData.products[i]
                                              .product_id,
                                          ),
                                      )}
                                      onChange={(selectedOption) => {
                                        let list = [
                                          ...internalDocumentData.products,
                                        ];
                                        list[i].product_id = selectedOption
                                          ? selectedOption.value
                                          : null;
                                        setInternalDocumentData({
                                          ...internalDocumentData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i); // validation
                                        setSelectedProduct(selectedOption);
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Product"}
                                    />
                                    {errorsPro[i]?.product_id && (
                                      <small className="text-danger">
                                        {errorsPro[i].product_id}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>
                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("name")}
                                    </Label>
                                    <input
                                      type="text"
                                      className="form-control mb-2"
                                      placeholder="Name"
                                      value={product.name}
                                      onChange={(e) => {
                                        let list = [
                                          ...internalDocumentData.products,
                                        ];
                                        list[i].name = e.target.value;
                                        setInternalDocumentData({
                                          ...internalDocumentData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i); //validation
                                      }}
                                    />
                                    {errorsPro[i]?.name && (
                                      <small className="text-danger">
                                        {errorsPro[i].name}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("summary")}
                                    </Label>
                                    <input
                                      type="text"
                                      className="form-control mb-2"
                                      placeholder="Summary"
                                      value={product.summary}
                                      onChange={(e) => {
                                        let list = [
                                          ...internalDocumentData.products,
                                        ];
                                        list[i].summary = e.target.value;
                                        setInternalDocumentData({
                                          ...internalDocumentData,
                                          products: list,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("quantity")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Quantity"
                                      value={product.qty}
                                      onChange={(e) => {
                                        let list = [
                                          ...internalDocumentData.products,
                                        ];
                                        list[i].qty = parseFloat(
                                          e.target.value,
                                        );
                                        setInternalDocumentData({
                                          ...internalDocumentData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i);
                                      }}
                                    />
                                    {errorsPro[i]?.qty && (
                                      <small className="text-danger">
                                        {errorsPro[i].qty}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("price")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Price"
                                      value={product.price}
                                      onChange={(e) => {
                                        let list = [
                                          ...internalDocumentData.products,
                                        ];
                                        list[i].price = parseFloat(
                                          e.target.value,
                                        );
                                        setInternalDocumentData({
                                          ...internalDocumentData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i);
                                      }}
                                    />
                                    {errorsPro[i]?.price && (
                                      <small className="text-danger">
                                        {errorsPro[i].price}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("discount")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Discount"
                                      value={product.discount}
                                      onChange={(e) => {
                                        let list = [
                                          ...internalDocumentData.products,
                                        ];
                                        list[i].discount = parseFloat(
                                          e.target.value,
                                        );
                                        setInternalDocumentData({
                                          ...internalDocumentData,
                                          products: list,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </div>
                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("deduction")}
                                    </Label>
                                    <Select
                                      className="my-select-v"
                                      options={deductionList}
                                      value={deductionList.find(
                                        (item) =>
                                          item.value ===
                                          internalDocumentData.products[i]
                                            .deduction_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        let list = [
                                          ...internalDocumentData.products,
                                        ];
                                        list[i].deduction_id = selectedOption
                                          ? selectedOption.value
                                          : null;
                                        setInternalDocumentData({
                                          ...internalDocumentData,
                                          products: list,
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Deduction"}
                                    />
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("order")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Order"
                                      value={product.order}
                                      onChange={(e) => {
                                        let list = [
                                          ...internalDocumentData.products,
                                        ];
                                        list[i].order = parseFloat(
                                          e.target.value,
                                        );
                                        setInternalDocumentData({
                                          ...internalDocumentData,
                                          products: list,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("exemption_reason")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={exemptionList}
                                          value={exemptionList.find(
                                            (item) =>
                                              item.value ===
                                              internalDocumentData.products[i]
                                                .exemption_reason,
                                          )}
                                          onChange={(selectedOption) => {
                                            let list = [
                                              ...internalDocumentData.products,
                                            ];
                                            list[i].exemption_reason =
                                              selectedOption
                                                ? selectedOption.value
                                                : null;
                                            setInternalDocumentData({
                                              ...internalDocumentData,
                                              products: list,
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={
                                            "Select Exemption Reason"
                                          }
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-3"></div>

                                <div className="col-md-3"></div>
                                <div className="col-md-3"></div>

                                <div className="row">
                                  <div
                                    className="col-md-12"
                                    style={{
                                      marginTop: "15px",
                                      marginBottom: "15px",
                                    }}
                                  >
                                    {" "}
                                    <h5>{t("tax")}</h5>
                                    <button
                                      className="btn btn-primary"
                                      onClick={(e) => handleAddTax(e, i)}
                                      type="button"
                                    >
                                      + {t("add_tax")}
                                    </button>
                                  </div>
                                  {product?.taxes?.length > 0 ? (
                                    <div
                                      className="row justify-content-start"
                                      style={{
                                        maxHeight: "300px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {product?.taxes?.map((prop, j) => (
                                        <div className="col-md-6">
                                          <div className="fileupload-content px-4">
                                            <div
                                              className="row justify-content-start align-items-center mb-2"
                                              key={j}
                                            >
                                              {" "}
                                              <div className="col-md-6">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("tax")}
                                                  </Label>
                                                  <Select
                                                    className="my-select-v"
                                                    options={taxDataList}
                                                    value={taxDataList.find(
                                                      (item) =>
                                                        item.value ===
                                                        String(
                                                          internalDocumentData
                                                            .products[i].taxes[
                                                            j
                                                          ].tax_id,
                                                        ),
                                                    )}
                                                    onChange={(
                                                      selectedOption,
                                                    ) => {
                                                      let list = [
                                                        ...internalDocumentData.products,
                                                      ];
                                                      list[i].taxes[j].tax_id =
                                                        selectedOption
                                                          ? selectedOption.value
                                                          : null;
                                                      setInternalDocumentData({
                                                        ...internalDocumentData,
                                                        products: list,
                                                      });
                                                    }}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    placeholder={"Select Tax"}
                                                  />
                                                </FormGroup>
                                              </div>
                                              <div className="col-md-6">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("value")}
                                                  </Label>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Value"
                                                    value={prop.value}
                                                    onChange={(e) => {
                                                      let list = [
                                                        ...internalDocumentData.products,
                                                      ];
                                                      list[i].taxes[j].value =
                                                        e.target.value;
                                                      setInternalDocumentData({
                                                        ...internalDocumentData,
                                                        products: list,
                                                      });
                                                    }}
                                                  />
                                                </FormGroup>
                                              </div>
                                              <div className="col-md-6">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("order")}
                                                  </Label>
                                                  <input
                                                    type="Number"
                                                    className="form-control"
                                                    placeholder="Order"
                                                    value={prop.order}
                                                    onChange={(e) => {
                                                      let list = [
                                                        ...internalDocumentData.products,
                                                      ];
                                                      list[i].taxes[j].order =
                                                        e.target.value;
                                                      setInternalDocumentData({
                                                        ...internalDocumentData,
                                                        products: list,
                                                      });
                                                    }}
                                                  />
                                                </FormGroup>
                                              </div>
                                              <div className="col-md-4 d-flex align-item-center">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("cumulative")}
                                                  </Label>
                                                  <div className="col-xl-12">
                                                    <div className="input-div">
                                                      <div className="form-check">
                                                        <input
                                                          className="my-checkbox-1 form-check-input"
                                                          type="checkbox"
                                                          checked={
                                                            prop.cumulative ===
                                                            1
                                                          }
                                                          onChange={(e) => {
                                                            let list = [
                                                              ...internalDocumentData.products,
                                                            ];
                                                            list[i].taxes[
                                                              j
                                                            ].cumulative = e
                                                              .target.checked
                                                              ? 1
                                                              : 0;
                                                            setInternalDocumentData(
                                                              {
                                                                ...internalDocumentData,
                                                                products: list,
                                                              },
                                                            );
                                                          }}
                                                        />
                                                        <label className="form-check-label pl-2">
                                                          {t("Cumulative")}
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </FormGroup>
                                              </div>
                                              <div className="d-flex align-item-center">
                                                <button
                                                  className="btn btn-danger"
                                                  onClick={(e) =>
                                                    handleRemoveTax(e, i, j)
                                                  }
                                                >
                                                  <i className="bi bi-trash"></i>
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  ) : (
                                    <p className="text-muted">
                                      No tax list added.
                                    </p>
                                  )}
                                </div>
                              </div>

                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={(e) => handleRemoveProduct(e, i)}
                              >
                                <i className="bi bi-trash"></i>
                              </button>

                              <div className="row d-none">
                                <div
                                  className="col-md-12"
                                  style={{
                                    marginTop: "15px",
                                    marginBottom: "15px",
                                  }}
                                >
                                  <h5>{t("child_products")}</h5>
                                  <button
                                    className="btn btn-primary"
                                    onClick={(e) => handleAddChildProduct(e, i)}
                                    type="button"
                                  >
                                    + {t("add_child_product")}
                                  </button>
                                </div>

                                {product?.child_products?.map((child, k) => (
                                  <div key={k} className="card p-2 mb-2 border">
                                    <h6>Child Product {k + 1}</h6>

                                    <div className="row">
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label>{t("child_name")}</Label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={child.name}
                                            onChange={(e) => {
                                              let list = [
                                                ...internalDocumentData.products,
                                              ];
                                              list[i].child_products[k].name =
                                                e.target.value;
                                              setInternalDocumentData({
                                                ...internalDocumentData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label>{t("summary")}</Label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={child.summary}
                                            onChange={(e) => {
                                              let list = [
                                                ...internalDocumentData.products,
                                              ];
                                              list[i].child_products[
                                                k
                                              ].summary = e.target.value;
                                              setInternalDocumentData({
                                                ...internalDocumentData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label>{t("quantity")}</Label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={child.qty}
                                            onChange={(e) => {
                                              let list = [
                                                ...internalDocumentData.products,
                                              ];
                                              list[i].child_products[k].qty =
                                                parseFloat(e.target.value);
                                              setInternalDocumentData({
                                                ...internalDocumentData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label>{t("price")}</Label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={child.price}
                                            onChange={(e) => {
                                              let list = [
                                                ...internalDocumentData.products,
                                              ];
                                              list[i].child_products[k].price =
                                                parseFloat(e.target.value);
                                              setInternalDocumentData({
                                                ...internalDocumentData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                    </div>

                                    {/* Properties Section for child */}
                                    <div className="row mt-2">
                                      <h6>{t("properties")}</h6>
                                      <button
                                        className="btn btn-sm btn-primary"
                                        onClick={(e) =>
                                          handleAddChildProperty(e, i, k)
                                        }
                                        type="button"
                                      >
                                        + {t("add_property")}
                                      </button>
                                      {child?.properties?.map((prop, j) => (
                                        <div
                                          key={j}
                                          className="d-flex gap-2 mb-2"
                                        >
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Title"
                                            value={prop.title}
                                            onChange={(e) => {
                                              let list = [
                                                ...internalDocumentData.products,
                                              ];
                                              list[i].child_products[
                                                k
                                              ].properties[j].title =
                                                e.target.value;
                                              setInternalDocumentData({
                                                ...internalDocumentData,
                                                products: list,
                                              });
                                            }}
                                          />
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Value"
                                            value={prop.value}
                                            onChange={(e) => {
                                              let list = [
                                                ...internalDocumentData.products,
                                              ];
                                              list[i].child_products[
                                                k
                                              ].properties[j].value =
                                                e.target.value;
                                              setInternalDocumentData({
                                                ...internalDocumentData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </div>
                                      ))}
                                    </div>

                                    {/* Taxes Section for child */}
                                    <div className="row mt-2">
                                      <h6>{t("taxes")}</h6>
                                      <button
                                        className="btn btn-sm btn-primary"
                                        onClick={(e) =>
                                          handleAddChildTax(e, i, k)
                                        }
                                        type="button"
                                      >
                                        + {t("add_tax")}
                                      </button>
                                      {child?.taxes?.map((tax, j) => (
                                        <div
                                          key={j}
                                          className="d-flex gap-2 mb-2"
                                        >
                                          <Select
                                            className="my-select-v"
                                            options={taxDataList}
                                            value={taxDataList.find(
                                              (item) =>
                                                item.value === tax.tax_id,
                                            )}
                                            onChange={(selectedOption) => {
                                              let list = [
                                                ...internalDocumentData.products,
                                              ];
                                              list[i].child_products[k].taxes[
                                                j
                                              ].tax_id = selectedOption
                                                ? selectedOption.value
                                                : null;
                                              setInternalDocumentData({
                                                ...internalDocumentData,
                                                products: list,
                                              });
                                            }}
                                            isSearchable
                                            isClearable
                                            placeholder="Select Tax"
                                          />
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Value"
                                            value={tax.value}
                                            onChange={(e) => {
                                              let list = [
                                                ...internalDocumentData.products,
                                              ];
                                              list[i].child_products[k].taxes[
                                                j
                                              ].value = parseFloat(
                                                e.target.value,
                                              );
                                              setInternalDocumentData({
                                                ...internalDocumentData,
                                                products: list,
                                              });
                                            }}
                                          />
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Order"
                                            value={tax.order}
                                            onChange={(e) => {
                                              let list = [
                                                ...internalDocumentData.products,
                                              ];
                                              list[i].child_products[k].taxes[
                                                j
                                              ].order = parseFloat(
                                                e.target.value,
                                              );
                                              setInternalDocumentData({
                                                ...internalDocumentData,
                                                products: list,
                                              });
                                            }}
                                          />
                                          <input
                                            type="checkbox"
                                            checked={tax.cumulative === 1}
                                            onChange={(e) => {
                                              let list = [
                                                ...internalDocumentData.products,
                                              ];
                                              list[i].child_products[k].taxes[
                                                j
                                              ].cumulative = e.target.checked
                                                ? 1
                                                : 0;
                                              setInternalDocumentData({
                                                ...internalDocumentData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </div>
                                      ))}
                                    </div>

                                    {/* Remove child button */}
                                    <button
                                      className="btn btn-danger mt-2"
                                      onClick={(e) =>
                                        handleRemoveChildProduct(e, i, k)
                                      }
                                    >
                                      <i className="bi bi-trash"></i>{" "}
                                      {t("remove_child_product")}
                                    </button>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="row">
                          <div className="col ms-2">
                            <button
                              type="button"
                              className="back-btn"
                              onClick={() => navigate("/internalDocuments")}
                            >
                              <i className="bi bi-arrow-left"> </i> {t("back")}
                            </button>
                          </div>
                          <div className="col">
                            <div className="d-flex justify-content-end nxt-btn">
                              {btnLoader === true ? (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  Loading...
                                </button>
                              ) : (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  {t("submit")} <i className="bi bi-check2"></i>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AddInternalDocuments;
